import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import pajero from "./../../../../assets/info/pajero-hero.jpg";
import ride from "./../../../../assets/info/mitsubishi-pajero/ride-height-diagram-spaced_1_.jpg";
import { Link } from "react-router-dom";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const MitsubishiPajero = () => {
  useSmallNav("Mitsubishi Pajero");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Mitsubishi Pajero"} bolder />
        <InfoHero image={pajero} />
        <InfoGrid>
          <div>
            <InfoHeader text={"To, które ja chcę?"} size="smaller" />
            <p>
              To raczej zależy od tego, co zamierzasz osiągnąć. Dla tych, którzy
              po prostu szukają części zamiennych, aby zastąpić te oryginalne
              już zużyte, oferujemy szeroki wybór wysokiej jakości części
              zamienne. W przypadku osób, które szukają opcjonalnego zawieszenie
              regulowanego elektronicznie, niestety nie oferujemy obecnie
              zamiennika. Są one dostępne tylko u producenta Mitsubishi. Możliwe
              jest dopasowanie naszych amortyzatorów do pojazdów wyposażonych w
              regulowane zawieszenie, ale pozbawia je to funkcji regulacji.
            </p>
            <p>
              Jeśli chcesz zwiększyć wysokość swojego pojazdu lub przewozić
              większe ciężary, mamy to czego potrzebujesz. Oferujemy szeroką
              gamę sprężyn i amortyzatorów do Twojego Pajero. Aby zaoszczędzić
              czas na szukaniu odpowiednich części, przygotowaliśmy dla Ciebie
              gotowe zestawy, które podniosą Twój samochód. Dodatkową korzyścią
              jest to, że zakup ich pozwoli Ci zaoszczędzić pieniądze!
            </p>
            <p>
              Wszystkie zestawy zawierają sprężyny przednie i tylne (tam gdzie
              konieczne również drążki skrętne) oraz 4 fantastyczne amortyzatory
              piankowe - Foam Cell. W celu poznania wszystkich zalet i
              właściwości amortyzatorów kliknij .
              <Link to={"/features"}>tutaj</Link>.
            </p>
            <InfoHeader
              text={"Oczywiście mogę podkręcić swoje drążki skrętne?"}
              size="smaller"
            />
            <p>
              Cóż, oczywiście, że tak. Jednak w przypadku większości starszych
              Pajero zauważysz, że tak jak każda sprężyna, drążki skrętne są
              opadnięte. Najczęściej ich podkręcenie daje tylko krótkotrwałą
              poprawę. Ponadto, nasze drążki skrętne dostarczają inną sztywność
              (podobnie jak nasze sprężyny), zaprojektowane są tak, aby działały
              w harmonii z naszymi amortyzatorami i określonymi dodatkowymi
              obciążeniami.
            </p>
            <InfoHeader
              text={"Czy zestaw posiada wszystko czego potrzebuję?"}
              size="smaller"
            />
            <p>
              Tak. Tam, gdzie ma to zastosowanie, amortyzatory są dostarczane w
              komplecie z wymiennymi tulejami itp. Oferujemy dodatkowe części do
              Pajero, takie jak ulepszone tuleje, np. poliuretanowe.
            </p>
            <InfoHeader
              text={"Jak wysokie będzie moje Pajero?"}
              size="smaller"
            />
            <p>
              Chociaż opisy zestawów podają przybliżone parametry, mogą one być
              trochę mylące. Jak wspomniano, sprężyny osiadają z czasem, więc
              1,5-calowe podwyższenie może okazać się nieco większe w
              rzeczywistości. Aby upewnić się, że dokładnie wiesz, co
              otrzymujesz, podajemy również prawdopodobną wysokość.
            </p>
            <img src={ride} alt={"Jak wysokie będzie moje Pajero?"} />
            <p>
              Mierzy się ją od dolnego rantu felgi do nadkola. Zaletą tej metody
              jest to, że wybór opon nie ma wpływu na podaną wysokość. Schemat
              przedstawia wysokość 715 mm z kołami 17 ".
            </p>
            <p>
              Jeśli nadal nie jesteś pewien, czy mamy odpowiednie dla Ciebie
              części? Nie wiesz, który zestaw jest dla Ciebie odpowiedni?
              Skontaktuj się z nami, a nasz zespół zadba o to, że otrzymasz
              części odpowiednie do Twoich potrzeb.
            </p>
            <iframe
              title="MITSUBISHI PAJERO"
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mitsubishi")
              .models.find((e) => e.display === "Pajero & Shogun")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title="MITSUBISHI PAJERO"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/lCMrIc_WS7s"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title="MITSUBISHI PAJERO"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Mitsubishi" model="Shogun & Pajero" />
      </Container>
    </section>
  );
};

export default MitsubishiPajero;
